import { deviceTypes } from '@styles/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafbfd;

  /* Auth0 mq */
  [data-device='${deviceTypes.mobile}'] & {
    background: #fff;
  }
`;

export const Body = styled.div`
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 8px 26px rgba(0, 0, 0, 0.12);
  padding: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 431px;
  width: 100%;

  /* Auth0 mq */
  [data-device='${deviceTypes.mobile}'] & {
    box-shadow: unset;
    background: #fff;
    padding: 16px;
    height: 100%;
    max-height: max-content;
    overflow: auto;
  }
`;

export const Button = styled.button`
  background: #1371fe;
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  text-align: center;
  padding: 8px;
`;

export const Description = styled.div`
  width: 100%;
  text-align: center;
  color: #000;
  font-size: 16px;
`;

export const Email = styled.div`
  width: 100%;
  text-align: center;
  color: #000;
  font-size: 16px;
  font-weight: 600;
`;

export const Statuses = styled.div`
  width: 100%;
`;

export const Name = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
`;

export const TitleResult = styled.div`
  display: flex;
  align-items: center;
`;

export const Requirements = styled.div`
  color: #1a1b1c;
  font-size: 14px;
  font-weight: 500;
`;

export const Logo = styled.img`
  width: 99px;
  height: 28px;
`;
